import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
// import building1 from "../../assets/building1.jpg";
// import naloffice from "../../assets/naloffice.jpg";
import './company.css';
import Greetings from './GreetSection';

class Company extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>会社情報 | 日本アドバンストリーダーズソフトウェア株式会社</title>
                </Helmet>
                <div className='container-box banner-container' id='company-banner-container'>
                    <div className='overlay'></div>
                    <div className='row'>
                        <div className='col'>
                            <h1>会社情報</h1>
                            <h3>COMPANY</h3>
                        </div>
                    </div>
                </div>
                <Greetings />
                <div className="container-box" id="company">
                    <div className="row row-title my-4">
                        <div className="col col-hr"><hr /></div>
                        <div className="col-12 col-md-6">
                            <h1 className="text-blue" >会社概要</h1>
                            <h5>COMPANY PROFILE</h5>
                        </div>
                        <div className="col col-hr"><hr /></div>
                    </div>
                    <div className="mb-4">
                        <div className="building_image_container">
                            <div id="building_image_1" className="building_image rounded"></div>
                            <div id="building_image_2" className="building_image rounded"></div>
                        </div>
                    </div>
                    <table className="csz_table csz_table_blue detail_history_table">
                        <thead>
                            <tr>
                                <th colSpan="1">社名</th>
                                <td>日本アドバンストリーダーズソフトウェア株式会社</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>略称</th>
                                <td>NAL Software (ナルソフトウェア)</td>
                            </tr>
                            <tr>
                                <th>本社所在地</th>
                                <td>
                                    <p>〒 450-0002<br />
                                        愛知県名古屋市中村区名駅3丁目11番22号 　ＩＴ名駅ビル7階<br />
                                        TEL:　052-433-7796<br />
                                        FAX:　052-433-7686<br />
                                        <a href="https://www.google.com/maps/place/%E3%80%92450-0002+%E6%84%9B%E7%9F%A5%E7%9C%8C%E5%90%8D%E5%8F%A4%E5%B1%8B%E5%B8%82%E4%B8%AD%E6%9D%91%E5%8C%BA%E5%90%8D%E9%A7%85%EF%BC%93%E4%B8%81%E7%9B%AE%EF%BC%91%EF%BC%91%E2%88%92%EF%BC%92%EF%BC%92+%EF%BC%A9%EF%BC%B4%E5%90%8D%E9%A7%85%E3%83%93%E3%83%AB/@35.1746426,136.8833328,17z/data=!3m1!4b1!4m5!3m4!1s0x600376c2e753dea1:0xf3c02d085ea2b753!8m2!3d35.1746426!4d136.8855215" rel="noreferrer" target="_blank">MAP</a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th>東京支社所在地</th>
                                <td>
                                    <p>〒 160-0023<br />
                                        東京都新宿区西新宿1丁目13番12号　西新宿昭和ビル10階<br />
                                        TEL:　050-3816-7622 <br />
                                        {/* FAX:　03-6275-1716 <br /> */}
                                        <a href="https://www.google.com/maps/place/%E8%A5%BF%E6%96%B0%E5%AE%BF%E6%98%AD%E5%92%8C%E3%83%93%E3%83%AB/@35.6897924,139.6944928,17z/data=!3m1!4b1!4m5!3m4!1s0x60188cd150e55555:0x719339ef5298ec00!8m2!3d35.6897881!4d139.6966815" rel="noreferrer" target="_blank">MAP</a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th>主な事業内容</th>
                                <td><p>
                                    ソフトウェアの開発及びコンピュータ関連事業全般<br />
                                    システムコンサルティング・システム設計・開発支援<br />
                                    パッケージ企画(開発)・販売
                                </p>
                                </td>
                            </tr>
                            <tr>
                                <th>業種分類</th>
                                <td>情報処理サービス業</td>
                            </tr>
                            <tr>
                                <th>設立</th>
                                <td>1989年10月</td>
                            </tr>
                            <tr>
                                <th>決算期</th>
                                <td>3月末日</td>
                            </tr>
                            <tr>
                                <th>資本金</th>
                                <td>2,550万円</td>
                            </tr>
                            <tr>
                                <th>上場</th>
                                <td>非上場</td>
                            </tr>
                            <tr>
                                <th>社員数</th>
                                <td>55名（2024年3月）</td>
                            </tr>
                            <tr>
                                <th>役員</th>
                                <td>代表取締役　高橋 徹</td>
                            </tr>
                            <tr>
                                <th>主取引銀行</th>
                                <td>三井住友銀行・三菱ＵＦＪ銀行</td>
                            </tr>
                            <tr>
                                <th>主要取引先</th>
                                <td><p id="main_customers">
                                    日本特殊陶業株式会社 様<br />
                                    株式会社川本製作所 様<br />
                                    株式会社オカグレート 様<br />
                                    株式会社佐野テック 様<br />
                                    株式会社ＬＩＸＩＬ 様<br />
                                    日本電気株式会社 様<br />
                                    ＮＥＣソリューションイノベータ株式会社 様<br />
                                    ＮＥＣネクサソリューションズ株式会社 様<br />
                                    東海ソフト株式会社 様<br />
                                    株式会社セイノー情報サービス 様<br />
                                    株式会社デンソーエスアイ 様<br />
                                    ドコモ・データコム株式会社 様<br />
                                    株式会社静鉄情報センター 様<br />
                                </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="container-box mb-5">
                    <div className="row row-title mb-4 mt-4">
                        <div className="col col-hr"><hr /></div>
                        <div className="col-12 col-md-6">
                            <h1 className="text-orange" id="history">沿革</h1>
                            <h5>DEVELOPMENT HISTORY</h5>
                        </div>
                        <div className="col col-hr"><hr /></div>
                    </div>
                    <table className="csz_table csz_table_orange detail_history_table">
                        <thead>
                            <tr>
                                <th>1989年10月</th>
                                <td>愛知県名古屋市中区栄にコンピュータシステム開発全般を事業内容として資本金1,000万円で設立</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>1991年01月</th>
                                <td>(社)愛知県情報サービス産業協会加入</td>
                            </tr>
                            <tr>
                                <th>1991年05月</th>
                                <td>事業拡張に伴い本社所在地を名古屋市西区名駅に変更</td>
                            </tr>
                            <tr>
                                <th>1997年06月</th>
                                <td>事業拡張に伴い本社所在地を名古屋市中区金山に変更</td>
                            </tr>
                            <tr>
                                <th>2000年12月</th>
                                <td>代表取締役社長に柴田 隆昌が就任　高野 裕八郎は会長に就任</td>
                            </tr>
                            <tr>
                                <th>2001年03月</th>
                                <td>事業拡張に伴い本社所在地を名古屋市中区正木に変更</td>
                            </tr>
                            <tr>
                                <th>2002年12月</th>
                                <td>業務拡張に伴い資本金2,550万円に増資</td>
                            </tr>
                            <tr>
                                <th>2005年01月</th>
                                <td>生産管理パッケージ「NK-PRISM」発表 1号ユーザ導入決定</td>
                            </tr>
                            <tr>
                                <th>2008年10月</th>
                                <td>財団法人 日本情報処理開発協会　プライバシーマーク取得</td>
                            </tr>
                            <tr>
                                <th>2010年10月</th>
                                <td>プライバシーマーク更新</td>
                            </tr>
                            <tr>
                                <th>2012年01月</th>
                                <td>会長退任・役員改定</td>
                            </tr>
                            <tr>
                                <th>2012年11月</th>
                                <td>本社所在地を中区伊勢山に変更</td>
                            </tr>
                            <tr>
                                <th>2014年09月</th>
                                <td>ISO（JIS Q）27001認証取得</td>
                            </tr>
                            <tr>
                                <th>2014年10月</th>
                                <td>プライバシーマーク更新終了</td>
                            </tr>
                            <tr>
                                <th>2015年07月</th>
                                <td>三田国際ビルに東京支社開設</td>
                            </tr>
                            <tr>
                                <th>2016年12月</th>
                                <td>労働者派遣事業許可証交付</td>
                            </tr>
                            <tr>
                                <th>2017年04月</th>
                                <td>ＮＥＣソリューションイノベータ株式会社様「全社プライムパートナー」に認定</td>
                            </tr>
                            <tr>
                                <th>2019年04月</th>
                                <td>ＮＥＣソリューションイノベータ株式会社様「PRIME PARTNER」に認定</td>
                            </tr>
                            <tr>
                                <th>2019年08月</th>
                                <td>健康宣言チャレンジ事業所に認定</td>
                            </tr>
                            <tr>
                                <th>2019年12月</th>
                                <td>労働者派遣事業許可有効期間を更新</td>
                            </tr>
                            <tr>
                                <th>2020年12月</th>
                                <td>グリーンシステム株式会社と資本業務提携を締結</td>
                            </tr>
                            <tr>
                                <th>2021年12月</th>
                                <td>事業拡張に伴い本社所在地を名古屋市中村区名駅に変更</td>
                            </tr>
                            <tr>
                                <th>2023年06月</th>
                                <td>事業拡張に伴い東京支社所在地を東京都新宿区西新宿に変更</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </React.Fragment>
        );
    }
}

export default Company;